"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rules = exports.RawRules = exports.MissingData = exports.Reasons = void 0;
exports.Reasons = {
    AutoPostProcess: "Automate:High Confidence",
    LowConfidenceProcess: "Do Not Automate:Low Confidence Prediction",
    MissingData: "Do Not Automate:Missing Data",
    SendToCoder: "Customer:Send To Coder"
};
var AutomatedRule = {
    Automate: [
        {
            decoration_category: "Automate",
            decoration_subcategory: "High Confidence",
            decoration_description: "Happy Path Prediction"
        },
        {
            decoration_category: "Automate",
            decoration_subcategory: "Direct to Bill Procedure",
            decoration_description: "Mammo Screening"
        }
    ]
};
var LowConfidenceRule = {
    "Do Not Automate": [
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Low Confidence Prediction",
            decoration_description: "Prediction Low Confidence"
        }
    ]
};
var NoSchedulingDeptRule = {
    Customer: [
        {
            decoration_category: "Customer",
            decoration_subcategory: "Excluded Send To Coder",
            decoration_description: "Sched Department not in Dictionary"
        }
    ]
};
var Vitalware = {
    "Do Not Automate": [
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Vitalware",
            decoration_description: "Failed CCI Edits"
        }
    ]
};
exports.MissingData = {
    "Do Not Automate": [
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Missing Data",
            decoration_description: "Missing data - date of service"
        },
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Missing Data",
            decoration_description: "Missing data - gender"
        }
    ]
};
var ComplexRules = {
    Customer: [
        {
            decoration_category: "Customer",
            decoration_subcategory: "Excluded From Prediction",
            decoration_description: "NSM Hybrid OR"
        }
    ],
    "Do Not Automate": [
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Low Confidence Rule",
            decoration_description: "Rule Low Confidence"
        },
        {
            decoration_category: "Do Not Automate",
            decoration_subcategory: "Excluded Work Queue",
            decoration_description: "Excluded IR Work Queue"
        }
    ],
    Automate: [
        {
            decoration_category: "Automate",
            decoration_subcategory: "Unconditional Automation",
            decoration_description: "NSM Hybrid OR"
        }
    ]
};
exports.RawRules = {
    AutomatedRule: AutomatedRule,
    LowConfidenceRule: LowConfidenceRule,
    ComplexRules: ComplexRules,
    MissingData: exports.MissingData,
    NoSchedulingDeptRule: NoSchedulingDeptRule
};
exports.Rules = {};
Object.entries(exports.RawRules).forEach(function (_a) {
    var _b = __read(_a, 2), k = _b[0], v = _b[1];
    exports.Rules[k] = JSON.stringify(v);
});
//# sourceMappingURL=rules-and-reasons.js.map